module.exports = __webpack_public_path__ + "static/ios_paso_1-a0246c60cc9f672cf33885ff797c4585.png";